import React from "react";
import Box from "../Box";
import Stack from "../Stack";
import Typography from "../Typography";
import Button from "../OldButton";
import { Platform, KeyboardAvoidingView, ScrollView } from "react-native";

interface PropTypes {
  children: React.ReactNode;
  title?: string;
  back?: () => void;
  dismiss?: () => void;
  hasContentPadding?: boolean;
  refScrollView?: any;
}

function ModalContent(props: PropTypes) {
  let { title, back, dismiss, hasContentPadding = true } = props;
  let hasTitleBar = title || back || dismiss;

  return (
    <Container refScrollView={props.refScrollView}>
      {hasTitleBar && (
        <Stack p="m" distribution="space-between">
          <Box>
            {back && (
              <Button onPress={back} size="s">
                <Typography color="secondary.main">بازگشت</Typography>
              </Button>
            )}
          </Box>
          {title && <Typography ff="mainBold">{title}</Typography>}
          <Box></Box>
        </Stack>
      )}
      <Box>{props.children}</Box>
    </Container>
  );
}

const webStyles =
  Platform.OS === "web"
    ? {
        container: {
          maxWidth: 768,
          marginRight: "auto",
          marginLeft: "auto",
          width: "100%",
          paddingBottom: "calc(env(safe-area-inset-bottom))",
        },
      }
    : {};
function Container(props: any) {
  let style = {
    backgroundColor: "#fff",
    borderTopRightRadius: 12,
    borderTopLeftRadius: 12,
    width: "100%",
    maxWidth: 768,
    ...webStyles.container,
  };

  if (Platform.OS === "ios") {
    return (
      <KeyboardAvoidingView behavior="position">
        <Box style={style}>{props.children}</Box>
      </KeyboardAvoidingView>
    );
  }

  return (
    <Box
      style={{
        maxHeight: "90%",
        ...style,
      }}
    >
      <ScrollView ref={props.refScrollView}>{props.children}</ScrollView>
    </Box>
  );
}

export default ModalContent;
